import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import withTranslation from '../../components/_hoc/withTranslation';
import ReactTableWrapper from './ReactTableWrapper';
import PagePagination from './PagePagination';
import { DEFAULT_FILTER } from '../../components/TableFilter/useTableFilter';

const StaticTablePagination = props => {
  const { t } = props;

  // pageSize
  let size = 5;
  if (props.data.length > 0) {
    size = props.data.length;
  }

  return (
    <div>
      <ReactTableWrapper {...props} pageSize={size} />
      {!props.hideBtn && props.onClickLoadMore && props.totalElements > props.data.length && (
        <Button
          fullWidth
          variant="outlined"
          style={{ marginTop: 10, height: 40 }}
          loading={props.loadingBtn}
          onClick={props.onClickLoadMore}
        >
          {t('staticTable_load')}
        </Button>
      )}
      <div className="mt2">
        <PagePagination
          pageSize={props.pageSize}
          pageSizes={props.pageSizes}
          changePageSize={props.changePageSize}
          pageNumber={props.pageNumber}
          totalPages={props.pageSize ? Math.ceil(props.totalElements / props.pageSize) : Math.ceil(props.totalElements / DEFAULT_FILTER.pageSize)}
          onPageChange={props.pagePagination}
          totalElements={props.totalElements}
        />
      </div>
    </div>
  );
};

StaticTablePagination.propTypes = {
  hideBtn: PropTypes.bool,
  filterable: PropTypes.bool,
  sortable: PropTypes.bool,
  loading: PropTypes.bool,
  data: PropTypes.array.isRequired,
  totalElements: PropTypes.number,
  columns: PropTypes.array.isRequired,
  onClickRow: PropTypes.func,
  onClickLoadMore: PropTypes.func,
  withoutHeader: PropTypes.bool,
  markText: PropTypes.string,
  onPageChange: PropTypes.func
};

StaticTablePagination.defaultProps = {
  hideBtn: false,
  filterable: true,
  loading: false,
  withoutHeader: false,
  totalElements: 0
};

export default withTranslation(StaticTablePagination);
